import { api } from 'app/app.api';

import {
  SmartResponsesApiArg,
  SmartResponsesApiResponse,
} from './smartConversation.types';

export const smartConversationApi = api.injectEndpoints({
  endpoints: (build) => ({
    postAiApiBetaConversationsSmartResponses: build.mutation<
      SmartResponsesApiResponse,
      SmartResponsesApiArg
    >({
      query: (queryArg) => {
        const url = '/ai/api/beta/conversations/smart_responses';
        return {
          url,
          type: 'knowledgeCdn',
          method: 'POST',
          body: queryArg.conversationResponseInput,
          path: url,
        };
      },
    }),
  }),
  overrideExisting: true,
});
